import { Navigate, useLocation } from "react-router-dom";
import { useAccountStore } from "../common/account";

export default function RequireAnonymous({ children }: { children: React.ReactNode }) {
    let accessTokenNotNull = useAccountStore(p => p.data?.accountData.accessToken != null);
    let location = useLocation();

    if (accessTokenNotNull) {
        return <Navigate to={location.state?.from || "/"} replace />;
    }

    return <>{children}</>;
}
